import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MobileNav } from '../mobile-nav';
import { SideNav } from './side-nav';
import {getTopBarHeight, TopNav} from './top-nav';
import { useMobileNav } from './use-mobile-nav';
import useAuth from "../../../hooks/useAuth";
import MobileBottomBar from "../../MobileBottomBar";
import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import FlowiseChat from "../../../components/FlowiseChat";
import localStrings from "../../../localStrings";
import { getMobileBottomBarHeight } from "../../MobileBottomBar";
// import {FullPageChat} from "flowise-embed-react";

const SIDE_NAV_WIDTH = 280;

const VerticalLayoutRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%',
  [theme.breakpoints.up('lg')]: {
    paddingLeft: SIDE_NAV_WIDTH
  }
}));

const VerticalLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  width: '100%'
});

export const VerticalLayout = (props) => {
  const { children, sections, navColor } = props;
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const mobileNav = useMobileNav();
  const {displayNavBar, currentBrand, currentEstablishment, userInDb, currentUser} = useAuth();
  const location = useLocation();
  const [token, setToken] = useState(null);
  
  // Vérifier si on est sur la page AI Chat
  const isAIChatPage = location.pathname.includes('/aiChat');
  
  // Récupérer les valeurs actuelles pour les utiliser comme dépendances
  const brandId = currentBrand()?.id;
  const establishmentId = currentEstablishment()?.id;

  useEffect(() => {
    if (userInDb && brandId && establishmentId) {
      setToken(`${userInDb.id}-${brandId}-${establishmentId}`);
    }
  }, [userInDb, brandId, establishmentId]);

  return (
    <div style={{ overflow: 'hidden'}}>
      <MobileBottomBar color={navColor}/>
      <TopNav onMobileNavOpen={mobileNav.handleOpen} />
      {(lgUp && displayNavBar) && (
        <SideNav
          color={navColor}
          sections={sections}
        />
      )}
      {!lgUp && (
        <MobileNav
          color={navColor}
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
          sections={sections}
        />
      )}
      <VerticalLayoutRoot
          sx={{
            paddingTop: `${getTopBarHeight() + 35}px`
          }}
      >
        <VerticalLayoutContainer>
          {children}
        </VerticalLayoutContainer>
      </VerticalLayoutRoot>
      
      {/* Composant FlowiseChat personnalisé - avec streaming, bouton stop et microphone */}
      {brandId && establishmentId && token && (
        <div style={{
          position: 'fixed',
          top: `${getTopBarHeight() + 35}px`,
          left: lgUp ? `${SIDE_NAV_WIDTH}px` : 0,
          right: 0,
          bottom: lgUp ? 0 : `${getMobileBottomBarHeight(lgUp)}px`,
          zIndex: isAIChatPage ? 1000 : -1,
          visibility: isAIChatPage ? 'visible' : 'hidden',
          opacity: isAIChatPage ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          backgroundColor: 'white',
          boxSizing: 'border-box',
          overflow: 'hidden'
        }}>
            <FlowiseChat
                key={token}
                chatflowId="3bad3c98-eae6-4e09-aa70-bb920bc5ea74"
                apiHost="https://flowise-abfk.onrender.com"
                sessionId={token}
                welcomeMessage={localStrings.chatAiwelcomeMessage}
                placeholder={localStrings.chatAiAskPlaceholder}
                title={localStrings.foodLytikAiAssistant}
                titleBackgroundColor="#3B81F6"
                titleTextColor="#ffffff"
                userAvatar={currentUser()?.photoURL}
                vars={{
                    restaurantName: currentEstablishment()?.name || '',
                    restaurantAdress: currentEstablishment()?.address || '',
                    address: currentEstablishment()?.address || '',
                    brandId: brandId || '',
                    establishementId: establishmentId || '',
                    timezone: currentEstablishment()?.timezone || '',
                    userEmail: currentUser()?.email || '',
                }}
            />
            {/* FullPageChat commenté - ne supporte pas le bouton stop ni le microphone
            <FullPageChat
                customCSS={`
              lite-badge,
              a#lite-badge,
              .lite-badge {
                display: none !important;
              }
            `}
                hideFlowiseBranding={true}
                chatflowid="c562ecde-c079-4c5b-80dd-b958c458302c"
                apiHost="https://flowise-abfk.onrender.com"
                isStream={true}
                sessionId={token}
                theme={{
                    chatWindow: {
                        showTitle: true,
                        welcomeMessage: localStrings.chatAiwelcomeMessage,
                        errorMessage: localStrings.chatAiErrorMessage,
                        clearChatOnReload: false,
                        textInput: {
                            placeholder: localStrings.chatAiAskPlaceholder,
                        }
                    },
                }}
                welcomeMessage={localStrings.chatAiwelcomeMessage}
                chatflowConfig={{
                    overrideConfig: {sessionId: token},
                    vars: {
                        restaurantName: currentEstablishment().name,
                        restaurantAdress: currentEstablishment().address,
                        brandId: currentBrand().id,
                        establishmentId: currentEstablishment().id,
                        timezone: currentEstablishment().timezone,
                    },
                }}
                showTitle
                title={localStrings.foodLytikAiAssistant}
                titleAvatarSrc="https://raw.githubusercontent.com/walkxcode/dashboard-icons/main/svg/google-messages.svg"
                titleBackgroundColor="#3B81F6"
                titleTextColor="#ffffff"
                fontSize={16}
                showAgentMessages={true}
                renderHTML
                isStream={true}
            />
            */}
        </div>
      )}
    </div>
  );
};

VerticalLayout.propTypes = {
  children: PropTypes.node,
  navColor: PropTypes.oneOf(['blend-in', 'discreet', 'evident']),
  sections: PropTypes.array
};
